/*
Slides

  --mountType <string::enum> | ['Side Mount', 'Under Mount']
  --closingMechanism <string::combobox>
  --length <float> | inches
  --loadWeight <float> | pounds
  --overTravel <float> | inches | default: 0
*/
import { length, loadWeight } from '@/modules/standardItems/schemas/baseFilters'
import hardwareFilters from '@/modules/standardItems/schemas/hardware/filters'

export default [
  ...hardwareFilters,
  {
    label: 'Mount Type',
    value: 'mountType',
    type: 'list',
    returnObject: false
  },
  {
    label: 'Closing Mechanism',
    value: 'closingMechanism',
    type: 'list',
    returnObject: false
  },
  length(),
  loadWeight(),
  {
    label: 'Over Travel',
    value: 'overTravel',
    type: 'range'
  }
]
